module.exports = __webpack_public_path__ + "static/the-giver-of-stars-289691ef1ad4b5a65c5b1fd4520a53d7.jpg";